import {addTrackingToAction} from '@vfde-sails/tracking';

import {
    GET_OVERLAY_CONTENT_FAILED,
    TRACK_OVERLAY,
} from './constant';
import { TOGGLE_OVERLAY } from 'Constant';

/** Getting the content of the overlay failed
 *
 * @param error
 * @returns { Array } - Action of type GET_OVERLAY_CONTENT_FAILED
 */
export function getOverlayContentFailed (error) {

    return {
        type: GET_OVERLAY_CONTENT_FAILED,
        error,
    };
}

/**
 * trackOverlay
 * @param newState
 */

export function trackOverlay (newState) {
    const {overlayState, overlayName} = newState;
    const action = overlayState ? 'show' : 'close';

    return addTrackingToAction({
        type: TRACK_OVERLAY,
    },
    'layover',
    {
        action,
        name: overlayName,
    },
    );
}

/**
 * toggleOverlay
 */
export function toggleOverlay() {
    return {
        type: TOGGLE_OVERLAY,

    };
}
